export const SITE = {
    brand: "100 Лидов",
    domain: "100lead.ru",
    tagline: "Лиды для юристов и адвокатов",
    phone: "",
    phoneLink: "",
    phoneNote: "Звонок по России бесплатный",
    email: "admin@100yuristov.com",
    office: "Москва, Шлюзовая набережная, д. 6, стр. 4",
    since: 2015,
};

export const REQUISITES = {
    legalName: "Индивидуальный предприниматель Тарасов Виталий Николаевич",
    shortName: "ИП Тарасов Виталий Николаевич",
    inn: "481103041073",
    ogrnip: "321710000058211",
    address:
        "Российская Федерация, 301246, Тульская обл., Щекинский м.р-н, г. Щекино, ул. Емельянова, д. 18",
};

export const DOCS = {
    updated: "20 августа 2026 г.",
};

// Показывать ли ссылку «Войти» в шапке. Значение берётся из REACT_APP_SHOW_LOGIN
// и подставляется на этапе сборки, поэтому после правки .env нужен перезапуск
// дев-сервера (или пересборка).
export const SHOW_LOGIN = ["true", "1", "yes"].includes(
    String(process.env.REACT_APP_SHOW_LOGIN || "")
        .trim()
        .toLowerCase()
);

export function pluralRu(n, one, few, many) {
    const abs = Math.abs(n) % 100;
    const n1 = abs % 10;
    if (abs > 10 && abs < 20) return many;
    if (n1 > 1 && n1 < 5) return few;
    if (n1 === 1) return one;
    return many;
}

export function yearsOnMarket() {
    return Math.max(1, new Date().getFullYear() - SITE.since);
}
